<template>
  <div class="agent-corp-mail-page">   
    <AgentCorpMailManager />
  </div>
</template>

<script>
import AgentCorpMailManager from '@/components/agent/AgentCorpMailManager.vue';

export default {
  name: 'AgentCorpMail',
  components: {
    AgentCorpMailManager
  },
  mounted() {
  }
};
</script>